import React from 'react';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';


const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');

const rootContainer = document.getElementById('root');

const root = createRoot(rootContainer);

root.render(
  //<React.StrictMode>
    <BrowserRouter basename={baseUrl}>
      <App />
    </BrowserRouter>
  //</React.StrictMode>,
    
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
